export default "__VITE_ASSET__qi83dwhP__"